import script from "./VTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VTab.vue?vue&type=script&setup=true&lang=js"

import "./VTab.vue?vue&type=style&index=0&id=6666bc95&lang=css&scoped=true"

import exportComponent from "/var/www/html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6666bc95"]])

export default __exports__